import { Task } from "twilio-taskrouter";
import { ErrorCode, ErrorSeverity, FlexSdkError } from "~/modules/error";
import { getLogger, LoggerName } from "~/modules/logger";
import { TaskRouterImpl } from "~/packages/taskrouter/TaskRouterImpl";

import { ContextManager } from "~/modules/contextManager/ContextManager";
import { getReservationsByTask, sendTrackingEvent } from "../../ActionUtils";
import { EVENTS } from "~/modules/analytics/Analytics";
import { AnalyticsImpl } from "~/modules/analytics/AnalyticsImpl";
import { CbmImpl } from "~/modules/cbm/CbmImpl";
import { Action } from "~/modules/actions/Action";


















export class EndConferenceForAll implements Action<Promise<Task>> {
    


    #taskSid: string;

    constructor(taskSid: string) {
        this.#taskSid = taskSid;
    }

    async run(ctx: {}) {
        const context = ctx as ContextManager;
        const taskRouter = context.getInstanceOf(TaskRouterImpl);
        const logger = getLogger(context)(LoggerName.Actions);
        const worker = taskRouter.worker;
        const analytics = context.getInstanceOf(AnalyticsImpl);
        const cbm = context.getInstanceOf(CbmImpl);

        logger.debug(`endConferenceForAll invoked with taskSid: ${this.#taskSid}`);

        if (!worker) {
            const errorMsg = "endConferenceForAll: Worker is not initialized";
            logger.error(errorMsg);
            return Promise.reject(new FlexSdkError(ErrorCode.SDK, { severity: ErrorSeverity.Error }, errorMsg));
        }

        const reservations = getReservationsByTask(worker, this.#taskSid);
        const reservation = reservations.find((res) => res.status === "accepted");
        if (!reservation) {
            const errorMsg = "endConferenceForAll: Reservation not found";
            logger.error(errorMsg);
            sendTrackingEvent(EVENTS.EndConferenceForAllCompleted, analytics, worker, errorMsg);
            throw new FlexSdkError(ErrorCode.SDK, { severity: ErrorSeverity.Error }, errorMsg);
        }
        try {
            const { task } = await cbm.endConference(reservation);
            sendTrackingEvent(EVENTS.EndConferenceForAllCompleted, analytics, worker);
            return task;
        } catch (error) {
            const errorMsg = `endConferenceForAll: Could not end conference with task sid ${reservation.task.sid}`;
            logger.error(errorMsg);
            sendTrackingEvent(EVENTS.UnholdParticipantCompleted, analytics, worker, errorMsg);
            throw new FlexSdkError(ErrorCode.SDK, { severity: ErrorSeverity.Error }, errorMsg);
        }
    }
}
